/* eslint-disable */

import { HiX } from 'react-icons/hi';
import Links from './components/Links';
import Logo from 'assets/new-logo.png';
import {
    renderThumb,
    renderTrack,
    renderView,
} from 'components/scrollbar/Scrollbar';
import { Scrollbars } from 'react-custom-scrollbars-2';
import routes from 'routes';
import routesBuyer from 'routesBuyer';
import Card from 'components/card';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdOutlineWhatsapp } from 'react-icons/md';

const SidebarHorizon = (props: {
    open: boolean;
    onClose: React.MouseEventHandler<HTMLSpanElement>;
    variant?: string;
}) => {
    const { open, onClose, variant } = props;
    const nav = useNavigate();

    useEffect(() => {
        // if (localStorage.getItem("user-type") === "seller") {
        //   setRoutes(routes);
        // }
    }, []);

    return (
        <div
            className={`sm:none duration-175 linear fixed !z-50 min-h-full transition-all md:!z-50 lg:!z-50 xl:!z-0 ${
                variant === 'auth' ? 'xl:hidden' : 'xl:block'
            } ${open ? '' : '-translate-x-full'}`}
        >
            <Card
                extra={`w-[285px] ml-3 sm:mr-4 sm:my-4 h-[96.5vh] m-7 !rounded-[20px]`}
            >
                <Scrollbars
                    autoHide
                    renderTrackVertical={renderTrack}
                    renderThumbVertical={renderThumb}
                    renderView={renderView}
                >
                    <div className="relative flex h-full flex-col justify-between">
                        <div>
                            <span
                                className="absolute right-4 top-4 block cursor-pointer xl:hidden"
                                onClick={onClose}
                            >
                                <HiX />
                            </span>
                            <div
                                className={`ml-[52px] mt-3 flex items-center lg:mt-[44px]`}
                            >
                                <div className="mx-auto mt-1 h-2.5 font-poppins text-[26px] font-bold uppercase text-navy-700 dark:text-white"></div>
                            </div>
                            <div className="mt-[38px] hidden h-px bg-gray-200 dark:bg-white/10 lg:block" />
                            <div className="mb-2">
                                {localStorage.getItem('user-type') ===
                                    'buyer' && (
                                    <div className="">
                                        <button
                                            className="mx-auto mt-4 flex w-[75%] items-center justify-center rounded-full bg-leadrs px-5 py-3 text-center text-xs font-bold text-white hover:bg-leadrsLight"
                                            onClick={() => {
                                                if (window.innerWidth < 567)
                                                    onClose({} as any);
                                                nav('/admin/create-order');
                                            }}
                                        >
                                            Faire une commande
                                        </button>
                                        <button
                                            className="mx-auto mt-3 flex w-[75%] items-center justify-center gap-2 rounded-full bg-[#10b981] px-5 py-3 text-center text-xs font-bold text-white hover:bg-green-500"
                                            onClick={() => {
                                                if (window.innerWidth < 567)
                                                    onClose({} as any);
                                                nav('/admin/purchase-order');
                                            }}
                                        >
                                            Faire un ordre d'achat
                                        </button>
                                    </div>
                                )}
                                {localStorage.getItem('user-type') ===
                                    'seller' && (
                                    <div className="">
                                        <button
                                            className="mx-auto mt-4 flex w-[75%] items-center justify-center rounded-xl bg-leadrs px-5 py-3 text-center text-xs font-bold text-white hover:bg-leadrsLight"
                                            onClick={() =>
                                                nav('/admin/seller-offer')
                                            }
                                        >
                                            Ajouter une offre
                                        </button>
                                    </div>
                                )}
                            </div>
                            {/* Nav item */}
                            <ul className="ml-[10px] mt-8 pt-1">
                                {localStorage.getItem('user-type') ===
                                'buyer' ? (
                                    <Links
                                        routes={routesBuyer}
                                        onClick={onClose}
                                    />
                                ) : (
                                    <Links routes={routes} onClick={onClose} />
                                )}
                                {/* Buyer Menu */}
                                <div
                                    className="ml-[55px] border-[#25D366] border-2 mt-4 flex h-[40px] w-[160px] gap-2 rounded-xl border px-4 hover:cursor-pointer hover:bg-gray-100"
                                    onClick={() =>
                                        window.open(
                                            'https://wa.me/447458107868 ',
                                            '_blank'
                                        )
                                    }
                                >
                                    <MdOutlineWhatsapp className="my-auto text-[#25D366] rounded-full" />
                                    <p className="my-auto text-[#25D366] flex text-sm">
                                        Besoin d'aide ?
                                    </p>
                                </div>
                                {localStorage.getItem('user-type') ===
                                    'buyer' && (
                                    <div className="mx-auto ml-9 mt-[70px] w-full">
                                        <div className="mx-auto justify-center">
                                            <p
                                                className="text-md text-gray-600 hover:cursor-pointer hover:underline"
                                                onClick={() => {
                                                    if (window.innerWidth < 567)
                                                        onClose({} as any);
                                                    nav('/admin/faq');
                                                }}
                                            >
                                                FAQ
                                            </p>
                                            <p
                                                className="text-md text-gray-600 hover:cursor-pointer hover:underline"
                                                onClick={() => {
                                                    if (window.innerWidth < 567)
                                                        onClose({} as any);
                                                    nav('/admin/settings');
                                                }}
                                            >
                                                Mon compte
                                            </p>
                                            <a
                                                href=" "
                                                className="mt-3 text-[10px] font-medium text-red-500 hover:text-red-500 hover:underline"
                                                onClick={() => {
                                                    localStorage.removeItem(
                                                        'token'
                                                    );
                                                    localStorage.removeItem(
                                                        'user'
                                                    );
                                                    nav('/auth/sign-in');
                                                }}
                                            >
                                                Se déconnecter
                                            </a>
                                        </div>
                                    </div>
                                )}
                                {/* Seller Menu */}
                                {localStorage.getItem('user-type') ===
                                    'seller' && (
                                    <div className="mx-auto ml-9 mt-2 w-full">
                                        <div className="mx-auto justify-center">
                                            <p
                                                className="text-base text-gray-600 hover:cursor-pointer hover:underline"
                                                onClick={() => {
                                                    if (window.innerWidth < 567)
                                                        onClose({} as any);
                                                    nav('/admin/faq');
                                                }}
                                            >
                                                FAQ
                                            </p>
                                            <p
                                                className="text-base text-gray-600 hover:cursor-pointer hover:underline"
                                                onClick={() => {
                                                    if (window.innerWidth < 567)
                                                        onClose({} as any);
                                                    nav('/admin/dashboard');
                                                }}
                                            >
                                                RGPD
                                            </p>
                                            <p
                                                className="text-base text-gray-600 hover:cursor-pointer hover:underline"
                                                onClick={() =>
                                                    window.open(
                                                        'https://go.crisp.chat/chat/embed/?website_id=d7156788-8d6d-40b5-ba31-f28c6b9dd7b0',
                                                        '_blank'
                                                    )
                                                }
                                            >
                                                Assistance
                                            </p>
                                            <p
                                                className="text-base text-gray-600 hover:cursor-pointer hover:underline"
                                                onClick={() => {
                                                    if (window.innerWidth < 567)
                                                        onClose({} as any);
                                                    nav('/admin/settings');
                                                }}
                                            >
                                                Mon compte
                                            </p>
                                            <a
                                                href=" "
                                                className="mt-3 text-[10px] font-medium text-red-500 hover:text-red-500 hover:underline"
                                                onClick={() => {
                                                    localStorage.removeItem(
                                                        'token'
                                                    );
                                                    localStorage.removeItem(
                                                        'user'
                                                    );
                                                    nav('/auth/sign-in');
                                                }}
                                            >
                                                Se déconnecter
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </ul>
                        </div>
                    </div>
                </Scrollbars>
            </Card>
        </div>
    );
};

export default SidebarHorizon;
